export enum Periods {
    Monthly = 'Monthly',
    Bimonthly = 'Bimonthly',
    Quarterly = 'Quarterly',
    Yearly = 'Yearly'
}
